<template>
  <div>
    <div class="d-flex mb-6">
      <BaseAvatar class="mr-4" />
      <div>
        <strong>{{ $t('GAME.QUIZ.YOU') }}</strong><br />
        <div v-if="!showAnswer">
          <span v-if="place === 'friends'">
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_FRIENDS') }}
          </span>
          <span v-else-if="place === 'school'">
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_SCHOOL') }}
          </span>
          <span v-else-if="place === 'twitter'">
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_NETWORKS') }}
          </span>
          <span v-else>
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_HOME') }}
          </span>
        </div>
        <div v-else>
          <span v-if="correct">
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_CORRECT') }}
          </span>
          <span v-else>
            {{ $t('GAME.QUIZ.YOU_SUBTITLE_NO') }}
          </span>
        </div>
      </div>
    </div>

    <div>
      <v-card
        v-for="(answer, i) in answers"
        :key="i"
        hover
        class="answer-card my-3 px-4 py-3 custom-border elevation-0"
        :class="{
          'answer-error': (i === selected && !answer.correct),
          'answer-correct': (selected !== -1 && answer.correct),
        }"
        @click="select(i)"
      >
        {{ $localized(answer, 'text') }}
      </v-card>
    </div>
  </div>
</template>

<style scoped>
.answer-card {
  position: relative;
}
  .answer-card.answer-error {
    background: var(--v-primary-lighten5);
  }
  .answer-card.answer-correct {
    background: var(--v-success-lighten5);
  }
  .answer-card:hover {
    border: 1px solid #d5d5d5 !important;
    box-shadow: 0px 4px 24px -8px rgba(0, 0, 0, 0.16) !important;
  }
  .answer-card:focus {
    border-radius: 8px;
  }
</style>

<script>
export default {
  name: 'QuizAnswers',
  props: {
    answers: {
      type: Array,
      default: () => [],
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
    place: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data: () => ({
    selected: -1,
  }),
  computed: {
    correct() {
      const answer = this.answers[this.selected];
      return answer && answer.correct;
    },
  },
  methods: {
    select(i) {
      if (this.selected !== -1) {
        return this.selected;
      }
      this.selected = i;
      this.$emit('select', i);
      return i;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selected = this.value;
      },
    },
  },
};
</script>
